export default __webpack_public_path__ + "static/media/land.ec419087.jpg";